"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@ebay/rum-web/client");
class RumLogger extends Marko.Component {
    onMount() {
        (0, client_1.initializeClientSideInlineLogger)()
            .then(() => {
            this.emit('logger-initialized', { error: null });
        })
            .catch((error) => {
            this.emit('logger-initialized', { error });
        });
    }
}
exports.default = RumLogger;
